module.exports = __webpack_public_path__ + "static/DragonB-e0676d495a3d3dcbb4f9fb003ef3c425.gif";